import PaymentTypes from '@/models/PaymentTypes';
import axios from '@/config/axios.config';
import vars from '@/config/vars';
import Vue from 'vue';

export default {
    namespaced: true,

    state: {
        isGooglePayEnabled: false,
        isReadyToPay: false,
        environment: '',
        selectedCard: {
            type: 'CARD',
            description: '',
            info: {
                cardNetwork: '',
                cardDetails: '',
                billingAddress: {
                    address1: '',
                    address2: '',
                    address3: '',
                    administrativeArea: '',
                    countryCode: '',
                    locality: '',
                    name: '',
                    postalCode: '',
                    sortingCode: '',
                }
            },
            tokenizationData: {
                type: 'PAYMENT_GATEWAY',
                token: ''
            }
        },
        consumer: {
            email: '',
            phone: '',
            fullName: '',
        },
        billingAddress: {
            address1: '',
            address2: '',
            address3: '',
            administrativeArea: '',
            countryCode: '',
            locality: '',
            name: '',
            postalCode: '',
            sortingCode: '',
        },
        PaymentMethodToken: {
            Type: 'AndroidPay',
            WalletKey: {
                encryptedMessage: '',
                ephemeralPublicKey: '',
                tag: ''
            },
            AdditionalData: {
                Signature: ''
            }
        },
        hasPhoneNumber: false,
        
        //Atributo principal para a prop do web component google-pay-button
        paymentRequest: {
            apiVersion: 2,
            apiVersionMinor: 0,
            allowedPaymentMethods: [
                {
                    type: 'CARD',
                    parameters: {
                        allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
                        allowedCardNetworks: [],
                        billingAddressRequired: true,
                        billingAddressParameters: {
                            format: 'FULL',
                            phoneNumberRequired: true
                        }
                    },
                    tokenizationSpecification: {
                        type: 'PAYMENT_GATEWAY',
                        parameters: {
                            gateway: 'cielo',
                            gatewayMerchantId: 'exampleGatewayMerchantId',
                        },
                    },
                },
            ],
            merchantInfo: {
                merchantId: '',
                merchantName: '',
            },
            transactionInfo: {
                totalPriceStatus: 'FINAL',
                totalPriceLabel: 'Total',
                totalPrice: '0.00',
                currencyCode: 'BRL',
                countryCode: 'BR',
            },
            emailRequired: true,
            shippingOptionRequired: false,
            shippingAddressRequired: false,
        },

        shippingAddress: {
            countryCode: '',
            postalCode: '',
            locality: '',
            administrativeArea: ''
        },
        shippingOption: {
            id: '',
        },
    },
    
    getters: {
        getSubmitModel(state, getters, rootState, rootGetters) {
            const submitModel = {
                ...rootGetters['cardPayment/getSubmitModel'],
                PaymentType: PaymentTypes.CREDIT_CARD,
                Guest: {
                    FullName: state.consumer.fullName,
                    Email: state.consumer.email,
                    Phone: state.consumer.phone,
                    Identity: rootState.customer.Identity,
                    IdentityType: rootState.customer.IdentityType,
                    AcceptAds: rootState.customer.AcceptAds,
                    UserAgent: rootState.customer.UserAgent
                },
                Wallet: state.PaymentMethodToken,
            };

            const billingModel = rootGetters['billingAddress/getSubmitModel'];

            if(!billingModel.BillingAddress) {
                return submitModel;
            }

            const isBillingValidForGooglePay = billingModel.BillingAddress.IsBillingAddressSameAsShipping
              || (billingModel.BillingAddress.ZipCode && billingModel.BillingAddress.City);

            if(!isBillingValidForGooglePay) {
                submitModel.Card.BillingAddress = null;
            }

            return submitModel;
        },

        getEnvironment: state => state.environment,

        getSelectedCard: state => state.selectedCard,

        getSelectedCardDescription: state => state.selectedCard.description,

        getPaymentRequest: state => state.paymentRequest,

        getBillingAddressCountryCode: state => state.billingAddress.countryCode,

        getState: state => state,

        getHasPhoneNumber: state => state.hasPhoneNumber,
    },

    mutations: {
        setFromRequest(state, data) {
            if(data.WalletMethodInformation && data.SupportedCardBrands) {
                const gpayCredentials = data.WalletMethodInformation.find(item => item.Name === 'Google Pay') || null;
                const supportedCardBrands = data.SupportedCardBrands.filter(obj => obj.Wallets && obj.Wallets.includes('GooglePay')).map(obj => obj.Name) || [];

                if(gpayCredentials && supportedCardBrands.length) {
                    state.isGooglePayEnabled = true;
                    state.paymentRequest.allowedPaymentMethods[0].tokenizationSpecification.parameters.gatewayMerchantId = gpayCredentials.WalletCredentials.GatewayMerchantId;;
                    state.paymentRequest.merchantInfo.merchantName = data.MerchantName;
                    state.paymentRequest.merchantInfo.merchantId = gpayCredentials.WalletCredentials.MerchantId;
                    state.environment = vars.ENVIRONMENT === 'PRD' ? 'PRODUCTION' : 'TEST';
                    state.paymentRequest.allowedPaymentMethods[0].parameters.allowedCardNetworks = supportedCardBrands.map(brand => brand.toUpperCase());
                    // state.environment = vars.USE_SIMULATED_MODE ? 'TEST' : 'PRODUCTION';
                }
            }

        },

        setFromPaymentData(state, data) {
            const jsonString = data.paymentMethodData.tokenizationData.token;
            const obj = JSON.parse(jsonString);

            state.selectedCard = data.paymentMethodData;
            state.consumer.fullName = data.paymentMethodData.info.billingAddress.name;
            state.consumer.phone = data.paymentMethodData.info.billingAddress.phoneNumber;
            state.consumer.email = data.email;
            state.billingAddress = data.paymentMethodData.info.billingAddress;
            state.PaymentMethodToken.WalletKey = obj.signedMessage;
            state.PaymentMethodToken.AdditionalData.Signature = obj.signature;
            state.hasPhoneNumber = !!data.paymentMethodData.info.billingAddress.phoneNumber;
        },

        setTotalPrice(state, totalPrice) {
            state.paymentRequest.transactionInfo.totalPrice = totalPrice;
        },

        setIsReadyToPay(state, isReadyToPay) {
            state.isReadyToPay = isReadyToPay;
        },

        // fluxo com entrega descartado
        setIntentCallbackWithShippingValues: (state) => {
            state.paymentRequest.shippingAddressRequired = true;
            state.paymentRequest.callbackIntents = ['PAYMENT_AUTHORIZATION', 'SHIPPING_ADDRESS'];

            let shippingAddressParameters = {
                allowedCountryCodes: ['BR'],
            };
            
            Vue.set(state.paymentRequest, 'shippingAddressParameters', shippingAddressParameters);
        },

        // fluxo com opção de envio descartado
        setShippingOptionParameters(state, shippingMethods) {
            state.paymentRequest.shippingOptionRequired = true;
            state.paymentRequest.callbackIntents = ['PAYMENT_AUTHORIZATION', 'SHIPPING_ADDRESS', 'SHIPPING_OPTION'];

            let shippingOptionParameters = {
                defaultSelectedOptionId: shippingMethods[0].Id,
                shippingOptions: shippingMethods.map(shippingMethod => {
                    return {
                        id: shippingMethod.Id,
                        label: shippingMethod.Description,
                        description: shippingMethod.FormattedPrice,
                    };
                })
            };

            Vue.set(state.paymentRequest, 'shippingOptionParameters', shippingOptionParameters);
        },

        setShippingAddress(state, shippingAddress) {
            state.shippingAddress = shippingAddress;
        },

        setShippingOption(state, shippingOption) {
            state.shippingOption = shippingOption;
        },

        setDefaultSelectedOptionId(state, defaultSelectedOptionId) {
            state.paymentRequest.shippingOptionParameters.defaultSelectedOptionId = defaultSelectedOptionId;
        },

        setPhone(state, phone) {
            state.consumer.phone = phone;
        },

        clearSelectedCard(state) {
            state.selectedCard = {
                type: 'CARD',
                description: '',
                info: {
                    cardNetwork: '',
                    cardDetails: '',
                    billingAddress: {
                        address1: '',
                        address2: '',
                        address3: '',
                        administrativeArea: '',
                        countryCode: '',
                        locality: '',
                        name: '',
                        postalCode: '',
                        sortingCode: '',
                    }
                },
                tokenizationData: {
                    type: 'PAYMENT_GATEWAY',
                    token: ''
                }
            };
        }
    },

    actions: {
        setPaymentMethod({ rootGetters, rootState }, paymentMethodId) {
            let paymentMethod = rootGetters['payment/getPaymentMethodById'](paymentMethodId);
            if (!paymentMethod)
                throw new Error('Meio de pagamento não suportado');

            rootState.payment.PaymentMethodId = paymentMethod.Id;
        },

        async fetchCardBrand({ dispatch, commit, rootState, state }, cardBin) {
            let paymentType = PaymentTypes.CREDIT_CARD;
            let preorderId = rootState.preorder.Id;

            let response;
            
            if (vars.USE_SIMULATED_MODE)
                response = await new Promise(resolve => setTimeout(() => resolve(buildSimulatedResponse()), 1000));
            else
                response = await axios.get(`brand/${preorderId}/${paymentType}/${cardBin}`);

            let paymentMethodId = response.data.PaymentMethodId;
            let maxNumberOfPayments = 0;

            if(response.data.InstallmentsInfo !== null && response.data.InstallmentsInfo.length > 0)
                maxNumberOfPayments = response.data.InstallmentsInfo.length;

            commit(
                'payment/setPaymentMethodNumberOfInstallments', 
                {
                    paymentMethodId, 
                    maxNumberOfPayments
                },
                { root: true });
            dispatch('setPaymentMethod', paymentMethodId);
        },

        setShippingAddress({ commit, dispatch, rootGetters }, shippingAddress) {
            commit('setShippingAddress', shippingAddress);
        },

        setShippingOption({ commit, dispatch, rootGetters }, shippingOption) {
            const methods = rootGetters['shippingType/getMethods'];

            if (methods.length && shippingOption.id !== 'shipping_option_unselected') {
                const selectedShippingMethod = methods.filter(method => method.id === shippingOption.id)[0];

                dispatch('shippingType/setShippingMethodId', selectedShippingMethod, { root: true });
                
                commit('setShippingOption', shippingOption);
                commit('setDefaultSelectedOptionId', shippingOption.id);
            }
        },

        setBillingAddress({ commit, dispatch, rootGetters, state }) {
            dispatch('billingAddress/setFromGooglePay', state.billingAddress, { root: true });
        }
    }
};

function buildSimulatedResponse() {
    return {
        data: {
            Brand:'Master',
            PaymentMethodId: 2,
            Success: true,
            ReasonError: null,
            InstallmentsInfo: [
                { Installments: 1 },
                { Installments: 2 },
                { Installments: 3 },
                { Installments: 4 },
                { Installments: 5 },
                { Installments: 6 },
                { Installments: 7 },
                { Installments: 8 }
            ]
        }
    };
}